import Vue from 'vue'
import Vuex from 'vuex'
import {
	FETCH_LOADING,
	ORIGIN,
	HASVALIDATE,
	PAGETYPE,
	KEEPALIVE

} from './mutations-type.js'
import { setStore } from '@/utils/index.js'

Vue.use(Vuex)

const mutations = {
	ORIGIN (state, origin) {
		state.origin = origin
	},
	FETCH_LOADING (state, fetchLoading) {
		state.fetchLoading = fetchLoading
	},
	HASVALIDATE (state, validate) {
		state.hasValidate = validate
	},
	PAGETYPE (state, type) {
		state.pageType = type
	},
	KEEPALIVE (state, type) {
		state.keepAlive = type
	}
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js